import React from 'react';

export default function LiquidNobleLogoWithText({
  width = 280,
  height = 50,
  className = '',
  iconOnly = false,
}) {
  // Calculate proportions based on your screenshot
  const iconSize = height;
  const textWidth = iconOnly ? 0 : width - iconSize - 12; // 12px gap

  if (iconOnly) {
    return (
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <rect width="50" height="50" rx="25" fill="#230822" />
        <path
          d="M28.2727 13H26.0909V18.2873C23.2025 15.6101 19.17 13 13 13V15.1818C20.4435 15.1818 24.3082 19.4002 27.2812 22.6452L27.4125 22.7885C29.2391 24.7812 30.7425 26.3754 32.6364 27.3207V13H30.4545V22.8437C30.0083 22.3854 29.5359 21.8761 29.0208 21.3142L28.8313 21.1073C28.6507 20.9099 28.4646 20.7068 28.2727 20.4992V13Z"
          fill="#dbbb6b"
        />
        <path
          d="M17.3636 22.6793C19.2575 23.6246 20.7609 25.2188 22.5875 27.2115L22.7188 27.3548C25.6918 30.5998 29.5565 34.8182 37 34.8182V37C30.83 37 26.7975 34.3899 23.9091 31.7127V37H21.7273V29.5008C21.5354 29.2932 21.3493 29.0901 21.1687 28.8927L20.9792 28.6858C20.4641 28.1239 19.9917 27.6146 19.5455 27.1563V37H17.3636V22.6793Z"
          fill="#dbbb6b"
        />
        <path
          d="M37 13H34.8182V28.0679C35.4836 28.2023 36.2048 28.2727 37 28.2727V13Z"
          fill="#dbbb6b"
        />
        <path
          d="M13 21.7273C13.7952 21.7273 14.5164 21.7977 15.1818 21.9321V37H13V21.7273Z"
          fill="#dbbb6b"
        />
        <path
          d="M24.1958 25.7372C21.1927 22.4611 18.4821 19.5455 13 19.5455V17.3636C19.4804 17.3636 22.7693 20.9518 25.7524 24.2064L25.8042 24.2628C28.8073 27.5389 31.5179 30.4545 37 30.4545V32.6364C30.5196 32.6364 27.2307 29.0482 24.2476 25.7936L24.1958 25.7372Z"
          fill="#dbbb6b"
        />
      </svg>
    );
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Purple circle with N icon */}
      <g>
        <rect
          width={iconSize}
          height={iconSize}
          rx={iconSize / 2}
          fill="#230822"
        />
        <g transform={`scale(${iconSize / 50})`}>
          <path
            d="M28.2727 13H26.0909V18.2873C23.2025 15.6101 19.17 13 13 13V15.1818C20.4435 15.1818 24.3082 19.4002 27.2812 22.6452L27.4125 22.7885C29.2391 24.7812 30.7425 26.3754 32.6364 27.3207V13H30.4545V22.8437C30.0083 22.3854 29.5359 21.8761 29.0208 21.3142L28.8313 21.1073C28.6507 20.9099 28.4646 20.7068 28.2727 20.4992V13Z"
            fill="#dbbb6b"
          />
          <path
            d="M17.3636 22.6793C19.2575 23.6246 20.7609 25.2188 22.5875 27.2115L22.7188 27.3548C25.6918 30.5998 29.5565 34.8182 37 34.8182V37C30.83 37 26.7975 34.3899 23.9091 31.7127V37H21.7273V29.5008C21.5354 29.2932 21.3493 29.0901 21.1687 28.8927L20.9792 28.6858C20.4641 28.1239 19.9917 27.6146 19.5455 27.1563V37H17.3636V22.6793Z"
            fill="#dbbb6b"
          />
          <path
            d="M37 13H34.8182V28.0679C35.4836 28.2023 36.2048 28.2727 37 28.2727V13Z"
            fill="#dbbb6b"
          />
          <path
            d="M13 21.7273C13.7952 21.7273 14.5164 21.7977 15.1818 21.9321V37H13V21.7273Z"
            fill="#dbbb6b"
          />
          <path
            d="M24.1958 25.7372C21.1927 22.4611 18.4821 19.5455 13 19.5455V17.3636C19.4804 17.3636 22.7693 20.9518 25.7524 24.2064L25.8042 24.2628C28.8073 27.5389 31.5179 30.4545 37 30.4545V32.6364C30.5196 32.6364 27.2307 29.0482 24.2476 25.7936L24.1958 25.7372Z"
            fill="#dbbb6b"
          />
        </g>
      </g>

      {/* Liquid Noble text */}
      <text
        x={iconSize + 12}
        y={height * 0.7}
        fill="#dbbb6b"
        fontSize={height * 0.6}
        fontFamily="Heebo, system-ui, -apple-system, sans-serif"
        fontWeight="600"
        letterSpacing="-0.02em"
      >
        Liquid Noble
      </text>
    </svg>
  );
}

// Alternative version with better typography control
export function LiquidNobleLogoAdvanced({
  width = 280,
  height = 50,
  className = '',
  iconOnly = false,
  textColor = '#dbbb6b',
}) {
  const iconSize = height;

  if (iconOnly) {
    return (
      <LiquidNobleLogoWithText
        width={iconSize}
        height={iconSize}
        iconOnly={true}
        className={className}
      />
    );
  }

  return (
    <div
      className={`inline-flex items-center gap-3 ${className}`}
      style={{ height }}
    >
      {/* Icon */}
      <LiquidNobleLogoWithText
        width={iconSize}
        height={iconSize}
        iconOnly={true}
      />

      {/* Text with better typography control */}
      <span
        style={{
          color: textColor,
          fontSize: height * 0.6,
          fontWeight: 600,
          fontFamily: 'Heebo, system-ui, -apple-system, sans-serif',
          letterSpacing: '-0.02em',
        }}
      >
        Liquid Noble
      </span>
    </div>
  );
}
